export default __webpack_public_path__ + "static/media/2301.063990fe.png";